class Accordion {
    constructor(elm) {
        this.$elm = $(elm);

        this.sectionClass = 'accordion-section';
        this.imageClass = 'accordion-sectionImage';
        this.activeClass = 'isActive';
        this.toggleClass = 'accordion-section--isOpen';
        this.contentClass = 'accordion-sectionContent';
        this.openSections = this.$elm.find(`.${this.sectionClass}:not(.${this.toggleClass}) .${this.contentClass}`);
        this.openSections.hide();
        this.closeOthersOnOpen = true;

        this.setEventListeners();
    }

    setEventListeners() {
        this.$elm.find('.accordion-sectionHeader')
            .on('click', this.onHeaderClick.bind(this));
    }

    openSection($section,$image) {
        if (this.closeOthersOnOpen) {
            $(`.${this.sectionClass}`).removeClass(this.toggleClass).find(`.${this.contentClass}`).slideUp(400);
            if ($image !== null) {
                $(`.${this.imageClass}`).removeClass(this.activeClass);
            }
        }
        if ($image !== null) {
            $image.addClass(this.activeClass);
        }
        $section.addClass(this.toggleClass).find(`.${this.contentClass}`).slideDown(400);
    }

    closeSection($section, $image) {
        if ($image !== null) {
            $image.removeClass(this.activeClass);
        }
        $section.removeClass(this.toggleClass).find(`.${this.contentClass}`).slideUp(400);

    }

    toggleSection($section) {
        var $image = null;
        if (typeof $section.data('image') !== 'undefined') {
            $image = $(`#${$section.data('image')}`);
        }
        if ($section.hasClass(this.toggleClass)) {
            this.closeSection($section,$image);
        } else {
            this.openSection($section,$image);
        }
    }

    onHeaderClick(event) {
        event.preventDefault();

        var $section = $(event.target).closest(`.${this.sectionClass}`);
        var $image = $(event.target).closest(`.${this.sectionClass}`);

        this.toggleSection($section);
    }
}

export default Accordion;